import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setErrors } from '../redux/globalSlice';
import ErrorMessage from '../components/ErrorMessage';

const ErrorMessageContainer = () => {
  const dispatch = useDispatch();
  const { errors } = useSelector((state) => state.global);
  return (
    <ErrorMessage
      errors={errors}
      onClose={() => {
        dispatch(setErrors([]));
      }}
    />
  );
};

export default ErrorMessageContainer;
